module.exports = DDC.WsmCommonData;


//////////////////
// WEBPACK FOOTER
// external "DDC.WsmCommonData"
// module id = 28
// module chunks = 0